import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7243166c")

_pushScopeId("data-v-7243166c")
const _hoisted_1 = { class: "px-16" }
const _hoisted_2 = { class: "pool" }
const _hoisted_3 = { class: "df-between df-middle mb-20" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Monitoring pool")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_6 = { class: "mb-8 t-center f-md pool-item" }
const _hoisted_7 = {
  key: 1,
  class: "c-tip f-md py-12 t-center mb-12"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" You are not qulified to use this indicator ")
const _hoisted_9 = { class: "signals pt-12" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Signals")
const _hoisted_11 = { class: "df-middle c-title f-sm my-8" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Signals will be pushed by system push notification, please make sure that the notification is on ")
const _hoisted_13 = { class: "py-16 df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Matrix = _resolveComponent("Matrix")
  const _component_HoldOn = _resolveComponent("HoldOn")
  const _component_PrimeOnly = _resolveComponent("PrimeOnly")
  const _component_Line = _resolveComponent("Line")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_t, {
          path: "indicatorsandsignals_5",
          class: "f-bold"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        (_ctx.isSignalAvailable)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "edit c-title f-sm df-middle",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
            }, [
              _createVNode(_component_t, { path: "indicatorsandsignals_6" }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_Icon, {
                name: "list",
                class: "sm"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isSignalAvailable)
        ? (_openBlock(), _createBlock(_component_HoldOn, {
            key: 0,
            content: _ctx.codeList,
            height: 80
          }, {
            default: _withId(() => [
              (_ctx.codeList.length)
                ? (_openBlock(), _createBlock(_component_Matrix, {
                    key: 0,
                    list: _ctx.codeList
                  }, {
                    default: _withId(({ item }) => [
                      _createVNode("p", _hoisted_6, _toDisplayString(item), 1)
                    ]),
                    _: 1
                  }, 8, ["list"]))
                : (_openBlock(), _createBlock("p", _hoisted_7, "There is no data!"))
            ]),
            _: 1
          }, 8, ["content"]))
        : (_openBlock(), _createBlock(_component_t, {
            key: 1,
            as: "div",
            path: "indicatorsandsignals_14",
            class: "no-auth f-md c-tip py-12 t-center mb-12"
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }))
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_t, {
        path: "indicatorsandsignals_7",
        as: "p",
        class: "f-bold"
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Icon, {
          name: "warn",
          sm: ""
        }),
        _createVNode(_component_t, {
          path: "indicatorsandsignals_8",
          class: "flex-1 ml-6",
          style: {"font-style":"italic"}
        }, {
          default: _withId(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Holder, { content: _ctx.list }, {
        default: _withId(() => [
          _createVNode(_component_List, { "list-data": _ctx.list }, {
            default: _withId(({ item }) => [
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_t, {
                  as: "p",
                  path: item.i18nPath,
                  class: "flex-1 mr-12 signal-title"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_component_PrimeOnly, {
                  checked: item.isChecked,
                  disabled: !item.available,
                  tag: _ctx.Switch,
                  value: item.id.toString(),
                  onChange: _ctx.change
                }, null, 8, ["checked", "disabled", "tag", "value", "onChange"])
              ]),
              _createVNode(_component_Line)
            ]),
            _: 1
          }, 8, ["list-data"])
        ]),
        _: 1
      }, 8, ["content"])
    ])
  ]))
})